<section id="campaign-table">
    <h3>Ongoing Thrifts</h3>
    <div class="container" style="overflow:scroll; height: 30vh;">
       
        <table class="styled-table" >
            <thead>
                <tr>
                    <th>S/N</th>
                    <th>Name</th>
                    <th>Duration</th>
                    <th>Status</th>
                    <th>Type</th>
                    <th>Owner</th>
                    <th>Creation Date</th>
                    <th>Action</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>1</td>
                    <td>The Oyebola Dynasty</td>
                    <td>2 Weeks</td>
                    <td>Active</td>
                    <td>Public</td>
                    <td>Thrively</td>
                    <td>Wed 05, 2022</td>
                    <td><a [routerLink]="['/thrift-details', 'ISA24495']" class="view-campaign">View</a></td>
                </tr>
              
            </tbody>
        </table>


    </div>
</section>